import React, { useState, useEffect } from 'react';
import {
  Box, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';

const TaskFilterDialog = ({ open, onClose, currentFilters, onApplyFilters, onClearFilters }) => {
  const [localFilters, setLocalFilters] = useState(currentFilters);
  
  // Reset local filters when dialog opens
  useEffect(() => {
    if (open) {
      setLocalFilters(currentFilters);
    }
  }, [open, currentFilters]);
  
  const handleChange = (event) => {
    setLocalFilters({
      ...localFilters,
      [event.target.name]: event.target.value
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Filter Tasks
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="status-filter-label">Status</InputLabel>
            <Select
              labelId="status-filter-label"
              id="status-filter"
              name="status"
              value={localFilters.status}
              label="Status"
              onChange={handleChange}
            >
              <MenuItem value="">All Statuses</MenuItem>
              <MenuItem value="PENDING">Pending</MenuItem>
              <MenuItem value="PROCESSING">Processing</MenuItem>
              <MenuItem value="COMPLETED">Completed</MenuItem>
              <MenuItem value="FAILED">Failed</MenuItem>
              <MenuItem value="VALIDATED">Validated</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl fullWidth>
            <InputLabel id="data-source-filter-label">Data Source</InputLabel>
            <Select
              labelId="data-source-filter-label"
              id="data-source-filter"
              name="dataSource"
              value={localFilters.dataSource}
              label="Data Source"
              onChange={handleChange}
            >
              <MenuItem value="">All Sources</MenuItem>
              <MenuItem value="toast-pos">Toast POS</MenuItem>
              <MenuItem value="aloha">Aloha</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl fullWidth>
            <InputLabel id="data-category-filter-label">Data Category</InputLabel>
            <Select
              labelId="data-category-filter-label"
              id="data-category-filter"
              name="dataCategory"
              value={localFilters.dataCategory}
              label="Data Category"
              onChange={handleChange}
            >
              <MenuItem value="">All Categories</MenuItem>
              <MenuItem value="orders">Orders</MenuItem>
              <MenuItem value="labor">Labor</MenuItem>
              <MenuItem value="delete">Delete</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClearFilters}>Clear All</Button>
        <Button 
          variant="contained" 
          onClick={() => onApplyFilters(localFilters)}
        >
          Apply Filters
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TaskFilterDialog;